/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления способами оплаты
 */

/**
 * Сервис способов оплаты
 */
export class PayMethodServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения списка способов оплаты.
   * Для роли master возвращаются способы оплаты для пользователя из токена.
   * Для роли service возвращаются способы оплаты пользователя, указанного в параметре запроса.
   * Метод доступен для: service, master
   */
  GetPayMethodList = (req?: GetPayMethodListRequestDto, init?: RequestInit): Promise<GetPayMethodListResponseDto> => {
    return fm.request<GetPayMethodListRequestDto, GetPayMethodListResponseDto>(`${this.host}/invoice/api/v1/pay_method/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления способа оплаты.
   * Удаляются способы оплаты для пользователя из токена.
   * Метод доступен для: master
   */
  DeletePayMethod = (req: DeletePayMethodRequestDto, init?: RequestInit): Promise<DeletePayMethodResponseDto> => {
    return fm.request<DeletePayMethodRequestDto, DeletePayMethodResponseDto>(`${this.host}/invoice/api/v1/pay_method/${encodeURIComponent(req.payMethodId)}${fm.buildQuery(req, ["payMethodId"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод установки способа оплаты по умолчанию.
   * Изменяются способы оплаты для пользователя из токена.
   * Метод доступен для: master
   */
  PostPayMethodDefault = (req: PostPayMethodDefaultRequestDto, init?: RequestInit): Promise<PostPayMethodDefaultResponseDto> => {
    return fm.request<PostPayMethodDefaultRequestDto, PostPayMethodDefaultResponseDto>(`${this.host}/invoice/api/v1/pay_method/${encodeURIComponent(req.payMethodId)}/default`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод добавления способа оплаты с типом \"Банковская карта\".
   * Добавляется банковская карта для пользователя из токена.
   * Метод доступен для: master
   */
  PostPayMethodBankcard = (req: PostPayMethodBankcardRequestDto, init?: RequestInit): Promise<PostPayMethodBankcardResponseDto> => {
    return fm.request<PostPayMethodBankcardRequestDto, PostPayMethodBankcardResponseDto>(`${this.host}/invoice/api/v1/pay_method/bankcard`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод добавления способа оплаты с типом \"СБП\".
   * Добавляется СБП для пользователя из токена.
   * Метод доступен для: master
   */
  PostPayMethodSbp = (req: PostPayMethodSbpRequestDto, init?: RequestInit): Promise<PostPayMethodSbpResponseDto> => {
    return fm.request<PostPayMethodSbpRequestDto, PostPayMethodSbpResponseDto>(`${this.host}/invoice/api/v1/pay_method/sbp`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов банковских карт
 */
export enum PayMethodCardType {
  /**
   * Значение не указано
   */
  CARD_TYPE_UNKNOWN = "CARD_TYPE_UNKNOWN",
  /**
   * Карта VISA
   */
  VISA = "VISA",
  /**
   * Карта EuroCard/MasterCard
   */
  EC_MC = "EC_MC",
  /**
   * Карта DinersClub
   */
  DCL = "DCL",
  /**
   * Карта JCB
   */
  JCB = "JCB",
  /**
   * Карта American Express
   */
  AMEX = "AMEX",
  /**
   * Платежная система \"Мир\"
   */
  MIR = "MIR",
}
/**
 * Справочник типов банковских карт
 */
export type PayMethodCardTypeResponseEnum = keyof typeof PayMethodCardType
/**
 * Справочник типов банковских карт
 */
export type PayMethodCardTypeRequestEnum = Exclude<PayMethodCardTypeResponseEnum, "CARD_TYPE_UNKNOWN">;

/**
 * Статус способа оплаты
 */
export enum PayMethodStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Исправный
   */
  VALID = "VALID",
  /**
   * Истекший
   */
  EXPIRED = "EXPIRED",
  /**
   * Заблокированный
   */
  BLOCKED = "BLOCKED",
}
/**
 * Статус способа оплаты
 */
export type PayMethodStatusTypeResponseEnum = keyof typeof PayMethodStatusType
/**
 * Статус способа оплаты
 */
export type PayMethodStatusTypeRequestEnum = Exclude<PayMethodStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов способов оплаты
 */
export enum PayMethodType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Банковская карта
   */
  BANK_CARD = "BANK_CARD",
  /**
   * Сервис быстрых платежей
   */
  SBP = "SBP",
  /**
   * Связка Сбербанка
   */
  SBER_BIND = "SBER_BIND",
}
/**
 * Справочник типов способов оплаты
 */
export type PayMethodTypeResponseEnum = keyof typeof PayMethodType
/**
 * Справочник типов способов оплаты
 */
export type PayMethodTypeRequestEnum = Exclude<PayMethodTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Запрос на удаление способа оплаты
 */
export type DeletePayMethodRequestDto = {
  /**
   * Идентификатор способа оплаты
   */
  payMethodId: string
}
/**
 * Ответ на запрос удаления способа оплаты
 */
export type DeletePayMethodResponseDto = {
}
/**
 * Запрос на получение списка способов оплаты
 */
export type GetPayMethodListRequestDto = {
  /**
   * Идентификатор пользователя
   */
  userId?: number
}
/**
 * Ответ на запрос получения списка способов оплаты
 */
export type GetPayMethodListResponseDto = {
  /**
   * Способы оплаты
   */
  data: PayMethodResponseDto[]
}
/**
 * Способ оплаты
 */
export type PayMethodRequestDto = {
  /**
   * Идентификатор способа оплаты
   */
  payMethodId: string
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Тип способа оплаты
   */
  type: PayMethodTypeRequestEnum
  /**
   * Признак активной записи
   */
  isActive: boolean
  /**
   * Способ оплаты по умолчанию
   */
  isDefault: boolean
  /**
   * Мобильный телефон, на который будут отправляться уведомления
   */
  payMethodContact?: string
  /**
   * Описание способа оплаты
   */
  payMethodDescription?: string
  /**
   * Псевдоним способа оплаты
   */
  payMethodAlias?: string
}
/**
 * Способ оплаты
 */
export type PayMethodResponseDto = {
  /**
   * Идентификатор способа оплаты
   */
  payMethodId: string
  /**
   * Идентификатор пользователя
   */
  userId: number
  /**
   * Тип способа оплаты
   */
  type: PayMethodTypeResponseEnum
  /**
   * Признак активной записи
   */
  isActive: boolean
  /**
   * Способ оплаты по умолчанию
   */
  isDefault: boolean
  /**
   * Мобильный телефон, на который будут отправляться уведомления
   */
  payMethodContact: string
  /**
   * Описание способа оплаты
   */
  payMethodDescription: string
  /**
   * Псевдоним способа оплаты
   */
  payMethodAlias: string
  /**
   * Тип банковской карты
   */
  readonly cardType: PayMethodCardTypeResponseEnum
  /**
   * Маскированный номер карты или идентификатора привязки счета СБП
   */
  readonly maskedNum: string
  /**
   * Наименование банка
   */
  readonly bankName: string
  /**
   * Признак авторизации БК
   */
  readonly isAuth: boolean
  /**
   * Статус способа оплаты
   */
  readonly statusType: PayMethodStatusTypeResponseEnum
  /**
   * Дата регистрации способа оплаты.
   * # Тип: DateTime
   */
  readonly registerAt: string | null
}
/**
 * Запрос на добавления способа оплаты с типом \"Банковская карта\"
 */
export type PostPayMethodBankcardRequestDto = {
  /**
   * URL для переадресации абонента в случае успешной регистрации карты
   */
  urlReturnOk: string
  /**
   * URL для переадресации абонента в случае неуспешной регистрации карты
   */
  urlReturnNo?: string
}
/**
 * Ответ на запрос добавления способа оплаты с типом \"Банковская карта\"
 */
export type PostPayMethodBankcardResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly error: PostPayMethodBankcardResponseErrorDto
  /**
   * Данные регистрации
   */
  readonly data: PostPayMethodBankcardResponseRegisterDataDto
}>
/**
 * Ошибка запроса
 */
export type PostPayMethodBankcardResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostPayMethodBankcardResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Данные регистрации
 */
export type PostPayMethodBankcardResponseRegisterDataDto = {
  /**
   * Идентификатор запроса на регистрацию
   */
  reqId: string
  /**
   * Ссылка для переадресации клиента для продолжения регистрации
   */
  urlRegistration: string
}
/**
 * Запрос установки способа оплаты по умолчанию
 */
export type PostPayMethodDefaultRequestDto = {
  /**
   * Идентификатор способа оплаты
   */
  payMethodId: string
}
/**
 * Ответ на запрос установки способа оплаты по умолчанию
 */
export type PostPayMethodDefaultResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostPayMethodDefaultResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostPayMethodDefaultResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostPayMethodDefaultResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на добавления способа оплаты с типом \"СБП\"
 */
export type PostPayMethodSbpRequestDto = {
  /**
   * URL для переадресации абонента в случае успешной регистрации карты
   */
  urlReturnOk: string
  /**
   * URL для переадресации абонента в случае неуспешной регистрации карты
   */
  urlReturnNo?: string
}
/**
 * Ответ на запрос добавления способа оплаты с типом \"СБП\"
 */
export type PostPayMethodSbpResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly error: PostPayMethodSbpResponseErrorDto
  /**
   * Данные регистрации
   */
  readonly data: PostPayMethodSbpResponseRegisterDataDto
}>
/**
 * Ошибка запроса
 */
export type PostPayMethodSbpResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostPayMethodSbpResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Данные регистрации
 */
export type PostPayMethodSbpResponseRegisterDataDto = {
  /**
   * Идентификатор запроса на регистрацию
   */
  reqId: string
  /**
   * Ссылка для переадресации клиента для продолжения регистрации
   */
  urlRegistration: string
  /**
   * Содержимое QR кода для регистрации платежного СБП-токена
   */
  sbpPayload: string
}
/**
 * Ошибка валидации
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибка валидации
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на удаление способа оплаты
   */
  "DeletePayMethodRequest": {
    "kind": "class",
    "text": "Запрос на удаление способа оплаты",
    "fields": {
      /**
       * Идентификатор способа оплаты
       */
      "payMethodId": {
        "type": "string",
        "text": "Идентификатор способа оплаты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления способа оплаты
   */
  "DeletePayMethodResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления способа оплаты",
  },
  /**
   * Запрос на получение списка способов оплаты
   */
  "GetPayMethodListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка способов оплаты",
    "fields": {
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
      },
    },
  },
  /**
   * Ответ на запрос получения списка способов оплаты
   */
  "GetPayMethodListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка способов оплаты",
    "fields": {
      /**
       * Способы оплаты
       */
      "data": {
        "type": "PayMethod",
        "text": "Способы оплаты",
      },
    },
  },
  /**
   * Способ оплаты
   */
  "PayMethod": {
    "kind": "class",
    "text": "Способ оплаты",
    "fields": {
      /**
       * Идентификатор способа оплаты
       */
      "payMethodId": {
        "type": "string",
        "text": "Идентификатор способа оплаты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пользователя
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип способа оплаты
       */
      "type": {
        "type": "PayMethod.Type",
        "text": "Тип способа оплаты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Признак активной записи
       */
      "isActive": {
        "type": "bool",
        "text": "Признак активной записи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Способ оплаты по умолчанию
       */
      "isDefault": {
        "type": "bool",
        "text": "Способ оплаты по умолчанию",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Мобильный телефон, на который будут отправляться уведомления
       */
      "payMethodContact": {
        "type": "string",
        "text": "Мобильный телефон, на который будут отправляться уведомления",
      },
      /**
       * Описание способа оплаты
       */
      "payMethodDescription": {
        "type": "string",
        "text": "Описание способа оплаты",
      },
      /**
       * Псевдоним способа оплаты
       */
      "payMethodAlias": {
        "type": "string",
        "text": "Псевдоним способа оплаты",
      },
      /**
       * Тип банковской карты
       */
      "cardType": {
        "type": "PayMethod.CardType",
        "text": "Тип банковской карты",
      },
      /**
       * Маскированный номер карты или идентификатора привязки счета СБП
       */
      "maskedNum": {
        "type": "string",
        "text": "Маскированный номер карты или идентификатора привязки счета СБП",
      },
      /**
       * Наименование банка
       */
      "bankName": {
        "type": "string",
        "text": "Наименование банка",
      },
      /**
       * Признак авторизации БК
       */
      "isAuth": {
        "type": "bool",
        "text": "Признак авторизации БК",
      },
      /**
       * Статус способа оплаты
       */
      "statusType": {
        "type": "PayMethod.StatusType",
        "text": "Статус способа оплаты",
      },
      /**
       * Дата регистрации способа оплаты.
       * # Тип: DateTime
       */
      "registerAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата регистрации способа оплаты.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Запрос на добавления способа оплаты с типом \"Банковская карта\"
   */
  "PostPayMethodBankcardRequest": {
    "kind": "class",
    "text": "Запрос на добавления способа оплаты с типом \"Банковская карта\"",
    "fields": {
      /**
       * URL для переадресации абонента в случае успешной регистрации карты
       */
      "urlReturnOk": {
        "type": "string",
        "text": "URL для переадресации абонента в случае успешной регистрации карты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * URL для переадресации абонента в случае неуспешной регистрации карты
       */
      "urlReturnNo": {
        "type": "string",
        "text": "URL для переадресации абонента в случае неуспешной регистрации карты",
      },
    },
  },
  /**
   * Ответ на запрос добавления способа оплаты с типом \"Банковская карта\"
   */
  "PostPayMethodBankcardResponse": {
    "kind": "class",
    "text": "Ответ на запрос добавления способа оплаты с типом \"Банковская карта\"",
    "fields": {
      /**
       * Ошибка валидации
       */
      "error": {
        "type": "PostPayMethodBankcardResponse.Error",
        "text": "Ошибка валидации",
      },
      /**
       * Данные регистрации
       */
      "data": {
        "type": "PostPayMethodBankcardResponse.RegisterData",
        "text": "Данные регистрации",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostPayMethodBankcardResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Данные регистрации
   */
  "PostPayMethodBankcardResponse.RegisterData": {
    "kind": "class",
    "text": "Данные регистрации",
    "fields": {
      /**
       * Идентификатор запроса на регистрацию
       */
      "reqId": {
        "type": "string",
        "text": "Идентификатор запроса на регистрацию",
      },
      /**
       * Ссылка для переадресации клиента для продолжения регистрации
       */
      "urlRegistration": {
        "type": "string",
        "text": "Ссылка для переадресации клиента для продолжения регистрации",
      },
    },
  },
  /**
   * Запрос установки способа оплаты по умолчанию
   */
  "PostPayMethodDefaultRequest": {
    "kind": "class",
    "text": "Запрос установки способа оплаты по умолчанию",
    "fields": {
      /**
       * Идентификатор способа оплаты
       */
      "payMethodId": {
        "type": "string",
        "text": "Идентификатор способа оплаты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос установки способа оплаты по умолчанию
   */
  "PostPayMethodDefaultResponse": {
    "kind": "class",
    "text": "Ответ на запрос установки способа оплаты по умолчанию",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostPayMethodDefaultResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostPayMethodDefaultResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на добавления способа оплаты с типом \"СБП\"
   */
  "PostPayMethodSbpRequest": {
    "kind": "class",
    "text": "Запрос на добавления способа оплаты с типом \"СБП\"",
    "fields": {
      /**
       * URL для переадресации абонента в случае успешной регистрации карты
       */
      "urlReturnOk": {
        "type": "string",
        "text": "URL для переадресации абонента в случае успешной регистрации карты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * URL для переадресации абонента в случае неуспешной регистрации карты
       */
      "urlReturnNo": {
        "type": "string",
        "text": "URL для переадресации абонента в случае неуспешной регистрации карты",
      },
    },
  },
  /**
   * Ответ на запрос добавления способа оплаты с типом \"СБП\"
   */
  "PostPayMethodSbpResponse": {
    "kind": "class",
    "text": "Ответ на запрос добавления способа оплаты с типом \"СБП\"",
    "fields": {
      /**
       * Ошибка валидации
       */
      "error": {
        "type": "PostPayMethodSbpResponse.Error",
        "text": "Ошибка валидации",
      },
      /**
       * Данные регистрации
       */
      "data": {
        "type": "PostPayMethodSbpResponse.RegisterData",
        "text": "Данные регистрации",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostPayMethodSbpResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Данные регистрации
   */
  "PostPayMethodSbpResponse.RegisterData": {
    "kind": "class",
    "text": "Данные регистрации",
    "fields": {
      /**
       * Идентификатор запроса на регистрацию
       */
      "reqId": {
        "type": "string",
        "text": "Идентификатор запроса на регистрацию",
      },
      /**
       * Ссылка для переадресации клиента для продолжения регистрации
       */
      "urlRegistration": {
        "type": "string",
        "text": "Ссылка для переадресации клиента для продолжения регистрации",
      },
      /**
       * Содержимое QR кода для регистрации платежного СБП-токена
       */
      "sbpPayload": {
        "type": "string",
        "text": "Содержимое QR кода для регистрации платежного СБП-токена",
      },
    },
  },
  /**
   * Ошибка валидации
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов банковских карт
   */
  "PayMethod.CardType": {
    "kind": "enum",
    "text": "Справочник типов банковских карт",
    "values": {
      /**
       * Значение не указано
       */
      "CARD_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Карта VISA
       */
      "VISA": {
        "i": 1,
        "text": "Карта VISA",
      },
      /**
       * Карта EuroCard/MasterCard
       */
      "EC_MC": {
        "i": 2,
        "text": "Карта EuroCard/MasterCard",
      },
      /**
       * Карта DinersClub
       */
      "DCL": {
        "i": 3,
        "text": "Карта DinersClub",
      },
      /**
       * Карта JCB
       */
      "JCB": {
        "i": 4,
        "text": "Карта JCB",
      },
      /**
       * Карта American Express
       */
      "AMEX": {
        "i": 5,
        "text": "Карта American Express",
      },
      /**
       * Платежная система \"Мир\"
       */
      "MIR": {
        "i": 6,
        "text": "Платежная система \"Мир\"",
      },
    },
  },
  /**
   * Статус способа оплаты
   */
  "PayMethod.StatusType": {
    "kind": "enum",
    "text": "Статус способа оплаты",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Исправный
       */
      "VALID": {
        "i": 1,
        "text": "Исправный",
      },
      /**
       * Истекший
       */
      "EXPIRED": {
        "i": 2,
        "text": "Истекший",
      },
      /**
       * Заблокированный
       */
      "BLOCKED": {
        "i": 3,
        "text": "Заблокированный",
      },
    },
  },
  /**
   * Справочник типов способов оплаты
   */
  "PayMethod.Type": {
    "kind": "enum",
    "text": "Справочник типов способов оплаты",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Банковская карта
       */
      "BANK_CARD": {
        "i": 1,
        "text": "Банковская карта",
      },
      /**
       * Сервис быстрых платежей
       */
      "SBP": {
        "i": 2,
        "text": "Сервис быстрых платежей",
      },
      /**
       * Связка Сбербанка
       */
      "SBER_BIND": {
        "i": 3,
        "text": "Связка Сбербанка",
      },
    },
  },
}